export const USER_MANAGEMENT_LANGUAGE_KEY = 'gestiontotal.user-management.language';

const messages = {
  es: {
    'language.label': 'Idioma de la interfaz',
    'language.spanish': 'Español',
    'language.english': 'English',
    'common.close': 'Cerrar',
    'common.cancel': 'Cancelar',
    'common.save': 'Guardar',
    'common.create': 'Crear',
    'common.update': 'Actualizar',
    'common.delete': 'Eliminar',
    'common.edit': 'Editar',
    'common.clear': 'Limpiar',
    'common.loading': 'Cargando…',
    'common.processing': 'Procesando solicitud…',
    'common.yesSave': 'Sí, guardar',
    'page.title': 'Lista de Usuarios por Grupo',
    'page.tutorial': 'Tutorial',
    'page.eventSummary': 'Resumen evento',
    'page.userApproval': 'Aprobación de usuarios',
    'page.downloadAll': 'Descargar todos los usuarios',
    'page.downloading': 'Descargando…',
    'page.loadingData': 'Cargando datos…',
    'page.searchGroup': 'Buscar grupo',
    'page.searchPlaceholder': 'Escribe el nombre de la empresa',
    'page.loadingUsers': 'Cargando usuarios…',
    'page.addModerator': 'Agregar Moderador',
    'page.previous': 'Anterior',
    'page.next': 'Siguiente',
    'page.pageOf': 'Página {current} de {total}',
    'page.wait': 'Por favor espera…',
    'page.errorsFound': 'Errores encontrados',
    'page.record': 'Registro {row}',
    'page.cutoffReached': 'Debido al paso de la fecha de corte no se pueden editar los registros.',
    'fields.selectPlaceholder': '-- Seleccione --',
    'fields.documentCC': 'CC - Cédula de Ciudadanía',
    'fields.documentCE': 'CE - Cédula de Extranjería',
    'fields.documentPassport': 'Pasaporte',
    'excel.group': 'Grupo',
    'excel.userType': 'Tipo de usuario',
    'excel.users': 'usuarios',
    'excel.usersSheet': 'Usuarios',
    'excel.loadingTemplate': 'Cargando configuración de plantilla…',
    'excel.downloadTemplate': 'Descargar plantilla de Excel para carga de usuarios ({categories})',
    'excel.beforeDownload': 'Antes de descargar',
    'excel.requiredFields': 'Campos obligatorios (requeridos/mandatorios):',
    'excel.templateHelp': 'La plantilla incluye todos los campos activos del evento. Puedes volver a subirla con encabezados en español o inglés; no elimines columnas necesarias.',
    'excel.downloadTemplateAction': 'Descargar plantilla',
    'excel.templateFilename': 'Plantilla para usuarios.xlsx',
    'excel.documentTypeNote': 'Valores permitidos: CC, CE, Pasaporte',
    'excel.invalidValueTitle': 'Valor inválido',
    'excel.documentTypeError': 'Usa el selector: CC, CE o Pasaporte.',
    'excel.allowedValuesNote': 'Selector. Valores permitidos: {values}',
    'excel.selectAllowedValue': 'Selecciona un valor permitido desde el desplegable.',
    'excel.multicheckOptionNote': 'Marca SI para incluir esta opción. (NO o vacío = no incluir)',
    'excel.yesNoError': 'Usa SI o NO.',
    'excel.multicheckAllowedNote': 'Multiselección: escribe opciones separadas por coma. Permitidas: {values}',
    'excel.multicheckNote': 'Multiselección: escribe opciones separadas por coma.',
    'excel.bulkUploadTitle': 'Carga masiva de {category}',
    'excel.chooseProcessing': 'Elige cómo quieres procesar este archivo.',
    'excel.overwriteShort': 'Sobrescribir',
    'excel.overwriteHelp': 'mantiene el comportamiento actual y reemplaza la información según el orden del Excel.',
    'excel.mergeShort': 'Actualizar y agregar',
    'excel.mergeHelp': 'cruza por los campos mandatorios activos del evento, actualiza coincidencias y agrega sólo los nuevos sin borrar los existentes.',
    'excel.unlimitedHelp': 'En modo sin límites, la carga masiva es incremental para conservar los registros existentes del grupo.',
    'excel.mergeAction': 'ACTUALIZAR Y AGREGAR',
    'excel.overwriteAction': 'SOBRESCRIBIR TODO',
    'excel.waitForEvent': 'Espera a que termine de cargar la información del evento.',
    'excel.includeWordpress': '¿Deseas incluir los grupos WordPress en esta descarga? Si eliges Cancelar, se excluirán para no alterar las métricas.',
    'excel.noGroups': 'No hay grupos para exportar en este evento.',
    'excel.noRows': 'No hay registros cargados ni cupos configurados para exportar todavía.',
    'excel.eventDownloaded': 'Se descargaron los usuarios del evento.',
    'excel.downloadFailed': 'No fue posible descargar todos los usuarios.',
    'excel.fileNotFound': 'No se encontró el archivo a procesar.',
    'excel.invalidCapacity': 'Capacidad inválida para esta categoría.',
    'excel.noMasterFields': 'No hay campos maestro mandatorios configurados para esta lista. Usa Sobrescribir o define al menos un mandatorio.',
    'excel.noSpaceForRows': 'No se agregó ningún registro: la lista no tiene espacios disponibles para {count} filas del archivo.',
    'excel.noDataRows': 'El archivo no contiene filas con información para agregar.',
    'excel.mergeCompleted': 'Carga inteligente completada. {updated} actualizados y {added} agregados.',
    'excel.rowsSkipped': '{count} no se agregaron por falta de espacios disponibles en la lista.',
    'excel.dataLoaded': 'Datos cargados y actualizados correctamente.',
    'excel.reviewBeforeSave': 'B001 - Los datos se colocaron correctamente; verifica la información antes de guardar.',
    'excel.processingError': 'Error al procesar la actualización.',
    'documents.downloadable': 'Descargables',
    'documents.title': 'Documentos descargables',
    'categories.staff': 'Staff',
    'categories.speakers': 'Expositores',
    'categories.attendees': 'Asistentes',
    'groups.create': 'Crear grupo',
    'groups.edit': 'Editar Grupo',
    'groups.name': 'Nombre del grupo:',
    'groups.freeModeTitle': 'Carga libre por categoría',
    'groups.freeModeHelp': 'Activa solo las listas que este grupo necesita. Luego podrás agregar registros manualmente o por Excel sin depender de cupos.',
    'groups.visibilityTitle': 'Visibilidad de listas',
    'groups.visibilityHelp': 'Activa solo las categorías que este grupo necesita para cargar sin límites.',
    'groups.delete': 'Eliminar Grupo',
    'groups.created': 'Grupo creado correctamente.',
    'groups.updated': 'Grupo actualizado correctamente.',
    'groups.deleted': 'Grupo borrado correctamente.',
    'groups.confirmDelete': '¿Estás seguro de que quieres eliminar este grupo?',
    'groups.close': 'Cerrar Grupo',
    'groups.closeConfirmation': 'Confirmación',
    'groups.closeQuestion': '¿Está seguro de que desea cerrar el grupo?',
    'groups.closeWarning': 'Asegúrate de haber guardado tus cambios antes de continuar. Una vez cerrado el grupo no podrás modificar sus usuarios.',
    'groups.closed': 'Grupo cerrado correctamente. La página se recargará en 5 segundos.',
    'groups.closeError': 'Error al procesar la solicitud.',
    'members.sendGroupInvitation': 'Enviar invitación grupal',
    'members.deleteAll': 'Borrar todos',
    'members.addRecord': 'Agregar registro',
    'members.sendInvitation': 'Enviar invitación',
    'members.approve': 'Aprobar',
    'members.deleteConfirmation': 'Confirmación de Borrado',
    'members.deleteQuestion': '¿Estás seguro de que deseas borrar este miembro?',
    'members.deleted': 'Miembro eliminado correctamente.',
    'members.reset': 'Miembro reiniciado correctamente.',
    'members.resetFailed': 'No se pudo reiniciar el miembro.',
    'members.requestFailed': 'Error al procesar la solicitud.',
    'members.onlySuperAdminReset': 'Solo un superadministrador puede borrar todos los usuarios de una lista.',
    'members.invalidResetTarget': 'No se pudo identificar el grupo o la lista a reiniciar.',
    'members.resetConfirm': 'Vas a borrar definitivamente {total} registro(s) de {category} del grupo "{group}".\n\nEsta acción elimina los usuarios y sus campos extra de la base de datos. ¿Deseas continuar?',
    'members.resetListFailed': 'No se pudo reiniciar la lista.',
    'members.resetListSuccess': 'Lista reiniciada correctamente.',
    'members.resetListError': 'Error al reiniciar la lista.',
    'members.approved': 'Usuario aprobado correctamente.',
    'members.approveError': 'Error al aprobar al usuario.',
    'moderators.name': 'Nombre',
    'moderators.email': 'Email',
    'moderators.actions': 'Acciones',
    'moderators.accessTicket': 'Ticket acceso',
    'moderators.none': 'Sin moderadores',
    'moderators.deletedWarning': 'Usuario eliminado; podría no reflejarse automáticamente.',
    'moderators.deleteError': 'Error al eliminar usuario.',
    'validation.invalidCountry': 'País inválido. Selecciona un valor de la lista.',
    'validation.onlyNumbers': 'Este campo solo permite números.',
    'validation.documentCharacters': 'Documento: solo letras y números, sin espacios ni símbolos.',
    'validation.sanitizedCharacters': 'Este campo solo permite letras, números y guion medio (-).',
    'validation.emailSpaces': 'Los espacios no están permitidos en el correo electrónico.',
    'validation.emailCharacter': 'Carácter no permitido en el correo electrónico.',
    'validation.duplicate': 'El campo {field} con valor {value} está duplicado en los usuarios a guardar.',
    'validation.invalidOption': 'El campo {field} tiene un valor inválido. Usa el selector.',
    'validation.required': 'El campo {field} es requerido.',
    'validation.documentFormat': 'El campo Documento debe contener solo letras y números sin espacios ni símbolos.',
    'validation.invalidEmail': "El correo electrónico '{email}' no es válido.",
    'validation.recordPrefix': 'Registro {row}: {message}',
    'validation.reviewing': 'Revisando registro {current} de {total}',
    'validation.backendError': 'Error al validar en backend.',
    'validation.alreadyRegistered': 'El campo {field} con valor {value} ya está registrado en otro registro del evento.',
    'validation.serverRejected': 'El registro no pasó la validación del campo {field}{value}.',
    'save.success': 'Información guardada correctamente.',
    'save.allSuccess': 'Guardado correctamente.',
    'save.membersError': 'Error al guardar los miembros.',
    'save.error': 'Error al guardar.',
    'save.noChanges': 'No hay cambios que guardar.',
    'invitations.groupError': 'Error al enviar invitación grupal.',
    'invitations.sent': 'Invitaciones enviadas.',
    'invitations.individualError': 'Error al enviar invitación individual.',
    'invitations.sentTo': 'Invitación enviada a {name}.',
    'magic.generate': 'Generar Magic Link',
    'magic.copy': 'Copiar Link',
    'magic.mailSent': 'Link enviado correctamente por correo.',
    'magic.mailFailed': 'No fue posible enviar el correo; comparte este link con el usuario.',
    'magic.copied': 'Link copiado al portapapeles.',
    'magic.copyError': 'Error al copiar el link.',
    'magic.send': 'Enviar Magic Links',
    'magic.sent': 'Enlaces mágicos generados y enviados correctamente.',
    'magic.processed': 'Solicitud procesada correctamente.',
    'bulkEmail.button': 'Enviar correos masivos del evento',
    'bulkEmail.sending': 'Enviando…',
    'bulkEmail.processing': 'Procesando envíos por grupo…',
    'bulkEmail.group': 'Grupo:',
    'bulkEmail.unnamed': '(sin nombre)',
    'bulkEmail.result': 'Resultado:',
    'bulkEmail.message': 'Mensaje:',
    'bulkEmail.processes': 'Procesos:',
    'bulkEmail.details': 'Ver detalle por grupo',
    'bulkEmail.status': 'Estado:',
    'bulkEmail.sentEmails': 'Correos enviados ({count})',
    'bulkEmail.missingToken': 'Falta el token del evento.',
    'bulkEmail.complete': 'Envío masivo finalizado.',
    'bulkEmail.error': 'Hubo un problema en el envío.',
    'bulkEmail.requestError': 'Error en la solicitud de envío masivo.',
    'registration.button': 'Registrar usuario / usuario legal',
    'registration.title': 'Registrar usuario en grupo',
    'registration.name': 'Nombre',
    'registration.email': 'Correo electrónico',
    'registration.legalRepresentative': 'Soy el representante legal',
    'registration.phone': 'Celular',
    'registration.identification': 'Identificación',
    'registration.position': 'Cargo',
    'registration.submit': 'Registrar',
    'registration.qrTitle': 'Escanee el QR para acceder a la plataforma',
    'registration.legalSuccess': 'Usuario legal y usuario registrado correctamente.',
    'registration.success': 'Usuario registrado correctamente.',
    'registration.error': 'Ocurrió un error.',
    'registration.connectionError': 'Error de conexión.',
    'company.button': 'Información de la empresa',
    'company.registerStandButton': 'Registrar empresa, grupo y usuario para registro de stands',
    'company.title': 'Información de la empresa',
    'company.detailTitle': 'Detalle de información de empresa',
    'company.idType': 'Tipo de Identificación',
    'company.idNumber': 'Número de Identificación',
    'company.businessName': 'Razón Social',
    'company.country': 'País',
    'company.city': 'Ciudad',
    'company.address': 'Dirección',
    'company.phone': 'Teléfono',
    'company.currency': 'Moneda',
    'company.website': 'Página Web',
    'company.legalName': 'Nombre del Representante Legal',
    'company.legalRepresentative': 'Representante legal',
    'company.legalEmail': 'Correo Electrónico',
    'company.legalId': 'Identificación del Representante',
    'company.confirmSave': '¿Deseas guardar los cambios del detalle de empresa?',
    'company.confirmTitle': 'Confirmar guardado',
    'company.no': 'No',
    'company.noPreviousData': 'Sin datos previos para este grupo.',
    'company.unableToSave': 'No se pudo guardar.',
    'company.saved': 'Información guardada correctamente.',
    'company.updated': 'Información de empresa actualizada correctamente.',
    'company.saveError': 'Error al guardar: {message}',
    'company.unexpectedError': 'Error inesperado',
    'company.connectionError': 'Error al conectar con el servidor.',
    'superAdmin.add': 'Agregar Super Administrador',
    'superAdmin.registerTitle': 'Registrar Administrador de Evento',
    'superAdmin.name': 'Nombre',
    'superAdmin.namePlaceholder': 'Nombre completo',
    'superAdmin.passwordPlaceholder': 'Debe tener al menos 8 caracteres',
    'superAdmin.email': 'Dirección de email',
    'superAdmin.password': 'Contraseña',
    'superAdmin.confirmPassword': 'Confirmar contraseña',
    'superAdmin.createUser': 'Crear usuario',
    'superAdmin.invalidEmail': 'Introduce una dirección de correo electrónico válida.',
    'superAdmin.passwordMismatch': 'Las contraseñas no coinciden.',
    'superAdmin.created': 'El superadministrador se creó correctamente.',
    'superAdmin.createError': 'Error al crear el usuario.',
    'eventAdmins.title': 'Administradores del evento',
    'eventAdmins.none': 'No hay administradores asignados a este evento todavía.',
    'eventAdmins.role': 'Rol',
    'eventAdmins.remove': 'Quitar',
    'eventAdmins.nameIfCreated': 'Nombre (si se crea)',
    'eventAdmins.addTitle': 'Agregar / asignar administrador',
    'eventAdmins.newUser': 'Crear usuario nuevo (si no existe)',
    'eventAdmins.passwordMin': 'La contraseña debe tener al menos 8 caracteres.',
    'eventAdmins.loadError': 'No se pudo cargar la lista de administradores.',
    'eventAdmins.ready': 'Listo.',
    'eventAdmins.removed': 'Administrador removido.',
    'eventAdmins.removeError': 'No se pudo remover el administrador.',
    'eventAdmins.saveError': 'Error al guardar el administrador.',
    'eventAdmins.removeConfirm': '¿Quitar a {email} como administrador de este evento?',
  },
  en: {
    'language.label': 'Interface language',
    'language.spanish': 'Español',
    'language.english': 'English',
    'common.close': 'Close',
    'common.cancel': 'Cancel',
    'common.save': 'Save',
    'common.create': 'Create',
    'common.update': 'Update',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.clear': 'Clear',
    'common.loading': 'Loading…',
    'common.processing': 'Processing request…',
    'common.yesSave': 'Yes, save',
    'page.title': 'Users by Group',
    'page.tutorial': 'Tutorial',
    'page.eventSummary': 'Event summary',
    'page.userApproval': 'User approval',
    'page.downloadAll': 'Download all users',
    'page.downloading': 'Downloading…',
    'page.loadingData': 'Loading data…',
    'page.searchGroup': 'Search group',
    'page.searchPlaceholder': 'Enter the company name',
    'page.loadingUsers': 'Loading users…',
    'page.addModerator': 'Add Moderator',
    'page.previous': 'Previous',
    'page.next': 'Next',
    'page.pageOf': 'Page {current} of {total}',
    'page.wait': 'Please wait…',
    'page.errorsFound': 'Errors found',
    'page.record': 'Record {row}',
    'page.cutoffReached': 'Records cannot be edited because the cutoff date has passed.',
    'fields.selectPlaceholder': '-- Select --',
    'fields.documentCC': 'CC - Citizenship ID',
    'fields.documentCE': 'CE - Foreigner ID',
    'fields.documentPassport': 'Passport',
    'excel.group': 'Group',
    'excel.userType': 'User type',
    'excel.users': 'users',
    'excel.usersSheet': 'Users',
    'excel.loadingTemplate': 'Loading template configuration…',
    'excel.downloadTemplate': 'Download the Excel user upload template ({categories})',
    'excel.beforeDownload': 'Before downloading',
    'excel.requiredFields': 'Required/master fields:',
    'excel.templateHelp': 'The template includes every active event field. You may upload it with Spanish or English headers; do not remove required columns.',
    'excel.downloadTemplateAction': 'Download template',
    'excel.templateFilename': 'User upload template.xlsx',
    'excel.documentTypeNote': 'Allowed values: CC, CE, Passport',
    'excel.invalidValueTitle': 'Invalid value',
    'excel.documentTypeError': 'Use the selector: CC, CE, or Passport.',
    'excel.allowedValuesNote': 'Selector. Allowed values: {values}',
    'excel.selectAllowedValue': 'Select an allowed value from the dropdown.',
    'excel.multicheckOptionNote': 'Select YES to include this option. (NO or blank = do not include)',
    'excel.yesNoError': 'Use YES or NO.',
    'excel.multicheckAllowedNote': 'Multiple selection: enter comma-separated options. Allowed values: {values}',
    'excel.multicheckNote': 'Multiple selection: enter comma-separated options.',
    'excel.bulkUploadTitle': 'Bulk upload for {category}',
    'excel.chooseProcessing': 'Choose how you want to process this file.',
    'excel.overwriteShort': 'Overwrite',
    'excel.overwriteHelp': 'replaces the information according to the row order in the Excel file.',
    'excel.mergeShort': 'Update and add',
    'excel.mergeHelp': 'matches active master fields, updates matches, and adds only new records without deleting existing ones.',
    'excel.unlimitedHelp': 'In unlimited mode, bulk upload is incremental so the group’s existing records are preserved.',
    'excel.mergeAction': 'UPDATE AND ADD',
    'excel.overwriteAction': 'OVERWRITE ALL',
    'excel.waitForEvent': 'Wait for the event information to finish loading.',
    'excel.includeWordpress': 'Do you want to include WordPress groups in this download? Choose Cancel to exclude them so the metrics are not affected.',
    'excel.noGroups': 'There are no groups to export for this event.',
    'excel.noRows': 'There are no uploaded records or configured slots to export yet.',
    'excel.eventDownloaded': 'The event users were downloaded.',
    'excel.downloadFailed': 'All event users could not be downloaded.',
    'excel.fileNotFound': 'The file to process was not found.',
    'excel.invalidCapacity': 'This category has an invalid capacity.',
    'excel.noMasterFields': 'This list has no configured master fields. Use Overwrite or define at least one master field.',
    'excel.noSpaceForRows': 'No records were added: the list has no available space for {count} rows from the file.',
    'excel.noDataRows': 'The file has no rows containing information to add.',
    'excel.mergeCompleted': 'Smart upload completed. {updated} updated and {added} added.',
    'excel.rowsSkipped': '{count} could not be added because the list has no available space.',
    'excel.dataLoaded': 'Data loaded and updated successfully.',
    'excel.reviewBeforeSave': 'B001 - The data was placed successfully; review it before saving.',
    'excel.processingError': 'There was an error processing the update.',
    'documents.downloadable': 'Downloads',
    'documents.title': 'Downloadable documents',
    'categories.staff': 'Staff',
    'categories.speakers': 'Speakers',
    'categories.attendees': 'Attendees',
    'groups.create': 'Create group',
    'groups.edit': 'Edit Group',
    'groups.name': 'Group name:',
    'groups.freeModeTitle': 'Unlimited entries by category',
    'groups.freeModeHelp': 'Enable only the lists this group needs. You can then add records manually or through Excel without capacity limits.',
    'groups.visibilityTitle': 'List visibility',
    'groups.visibilityHelp': 'Enable only the categories this group needs for unlimited uploads.',
    'groups.delete': 'Delete Group',
    'groups.created': 'Group created successfully.',
    'groups.updated': 'Group updated successfully.',
    'groups.deleted': 'Group deleted successfully.',
    'groups.confirmDelete': 'Are you sure you want to delete this group?',
    'groups.close': 'Close Group',
    'groups.closeConfirmation': 'Confirmation',
    'groups.closeQuestion': 'Are you sure you want to close the group?',
    'groups.closeWarning': 'Make sure you saved your changes before continuing. Once the group is closed, its users cannot be modified.',
    'groups.closed': 'Group closed successfully. The page will reload in 5 seconds.',
    'groups.closeError': 'There was an error processing the request.',
    'members.sendGroupInvitation': 'Send group invitation',
    'members.deleteAll': 'Delete all',
    'members.addRecord': 'Add record',
    'members.sendInvitation': 'Send invitation',
    'members.approve': 'Approve',
    'members.deleteConfirmation': 'Delete Confirmation',
    'members.deleteQuestion': 'Are you sure you want to delete this member?',
    'members.deleted': 'Member deleted successfully.',
    'members.reset': 'Member reset successfully.',
    'members.resetFailed': 'The member could not be reset.',
    'members.requestFailed': 'There was an error processing the request.',
    'members.onlySuperAdminReset': 'Only a super administrator can delete all users from a list.',
    'members.invalidResetTarget': 'The group or list to reset could not be identified.',
    'members.resetConfirm': 'You are about to permanently delete {total} record(s) from {category} in group "{group}".\n\nThis action removes the users and their extra fields from the database. Do you want to continue?',
    'members.resetListFailed': 'The list could not be reset.',
    'members.resetListSuccess': 'List reset successfully.',
    'members.resetListError': 'There was an error resetting the list.',
    'members.approved': 'User approved successfully.',
    'members.approveError': 'There was an error approving the user.',
    'moderators.name': 'Name',
    'moderators.email': 'Email',
    'moderators.actions': 'Actions',
    'moderators.accessTicket': 'Access ticket',
    'moderators.none': 'No moderators',
    'moderators.deletedWarning': 'User deleted; the change may not appear automatically.',
    'moderators.deleteError': 'There was an error deleting the user.',
    'validation.invalidCountry': 'Invalid country. Select a value from the list.',
    'validation.onlyNumbers': 'This field only accepts numbers.',
    'validation.documentCharacters': 'Document: letters and numbers only, without spaces or symbols.',
    'validation.sanitizedCharacters': 'This field only accepts letters, numbers, and hyphens (-).',
    'validation.emailSpaces': 'Spaces are not allowed in the email address.',
    'validation.emailCharacter': 'This character is not allowed in the email address.',
    'validation.duplicate': 'The {field} field with value {value} is duplicated among the users being saved.',
    'validation.invalidOption': 'The {field} field has an invalid value. Use the selector.',
    'validation.required': 'The {field} field is required.',
    'validation.documentFormat': 'The Document field must contain only letters and numbers, without spaces or symbols.',
    'validation.invalidEmail': "The email address '{email}' is invalid.",
    'validation.recordPrefix': 'Record {row}: {message}',
    'validation.reviewing': 'Reviewing record {current} of {total}',
    'validation.backendError': 'Backend validation failed.',
    'validation.alreadyRegistered': 'The {field} field with value {value} is already registered in another event record.',
    'validation.serverRejected': 'The record failed validation for the {field} field{value}.',
    'save.success': 'Information saved successfully.',
    'save.allSuccess': 'Saved successfully.',
    'save.membersError': 'There was an error saving the members.',
    'save.error': 'There was an error saving.',
    'save.noChanges': 'There are no changes to save.',
    'invitations.groupError': 'There was an error sending the group invitation.',
    'invitations.sent': 'Invitations sent.',
    'invitations.individualError': 'There was an error sending the individual invitation.',
    'invitations.sentTo': 'Invitation sent to {name}.',
    'magic.generate': 'Generate Magic Link',
    'magic.copy': 'Copy Link',
    'magic.mailSent': 'Link sent successfully by email.',
    'magic.mailFailed': 'The email could not be sent; share this link with the user.',
    'magic.copied': 'Link copied to the clipboard.',
    'magic.copyError': 'There was an error copying the link.',
    'magic.send': 'Send Magic Links',
    'magic.sent': 'Magic links generated and sent successfully.',
    'magic.processed': 'Request processed successfully.',
    'bulkEmail.button': 'Send event bulk emails',
    'bulkEmail.sending': 'Sending…',
    'bulkEmail.processing': 'Processing emails by group…',
    'bulkEmail.group': 'Group:',
    'bulkEmail.unnamed': '(unnamed)',
    'bulkEmail.result': 'Result:',
    'bulkEmail.message': 'Message:',
    'bulkEmail.processes': 'Processes:',
    'bulkEmail.details': 'View details by group',
    'bulkEmail.status': 'Status:',
    'bulkEmail.sentEmails': 'Emails sent ({count})',
    'bulkEmail.missingToken': 'The event token is missing.',
    'bulkEmail.complete': 'Bulk email completed.',
    'bulkEmail.error': 'There was a problem sending the emails.',
    'bulkEmail.requestError': 'There was an error requesting the bulk email send.',
    'registration.button': 'Register user / legal representative',
    'registration.title': 'Register user in group',
    'registration.name': 'Name',
    'registration.email': 'Email address',
    'registration.legalRepresentative': 'I am the legal representative',
    'registration.phone': 'Mobile phone',
    'registration.identification': 'Identification',
    'registration.position': 'Position',
    'registration.submit': 'Register',
    'registration.qrTitle': 'Scan the QR code to access the platform',
    'registration.legalSuccess': 'Legal representative and user registered successfully.',
    'registration.success': 'User registered successfully.',
    'registration.error': 'An error occurred.',
    'registration.connectionError': 'Connection error.',
    'company.button': 'Company information',
    'company.registerStandButton': 'Register company, group, and user for booth registration',
    'company.title': 'Company information',
    'company.detailTitle': 'Company information details',
    'company.idType': 'Identification type',
    'company.idNumber': 'Identification number',
    'company.businessName': 'Legal business name',
    'company.country': 'Country',
    'company.city': 'City',
    'company.address': 'Address',
    'company.phone': 'Phone',
    'company.currency': 'Currency',
    'company.website': 'Website',
    'company.legalName': 'Legal representative name',
    'company.legalRepresentative': 'Legal representative',
    'company.legalEmail': 'Email address',
    'company.legalId': 'Representative identification',
    'company.confirmSave': 'Do you want to save the changes to the company details?',
    'company.confirmTitle': 'Confirm save',
    'company.no': 'No',
    'company.noPreviousData': 'No previous data is available for this group.',
    'company.unableToSave': 'The information could not be saved.',
    'company.saved': 'Information saved successfully.',
    'company.updated': 'Company information updated successfully.',
    'company.saveError': 'Save error: {message}',
    'company.unexpectedError': 'Unexpected error',
    'company.connectionError': 'Could not connect to the server.',
    'superAdmin.add': 'Add Super Administrator',
    'superAdmin.registerTitle': 'Register Event Administrator',
    'superAdmin.name': 'Name',
    'superAdmin.namePlaceholder': 'Full name',
    'superAdmin.passwordPlaceholder': 'Must be at least 8 characters',
    'superAdmin.email': 'Email address',
    'superAdmin.password': 'Password',
    'superAdmin.confirmPassword': 'Confirm password',
    'superAdmin.createUser': 'Create user',
    'superAdmin.invalidEmail': 'Enter a valid email address.',
    'superAdmin.passwordMismatch': 'The passwords do not match.',
    'superAdmin.created': 'The super administrator was created successfully.',
    'superAdmin.createError': 'There was an error creating the user.',
    'eventAdmins.title': 'Event administrators',
    'eventAdmins.none': 'No administrators have been assigned to this event yet.',
    'eventAdmins.role': 'Role',
    'eventAdmins.remove': 'Remove',
    'eventAdmins.nameIfCreated': 'Name (if created)',
    'eventAdmins.addTitle': 'Add / assign administrator',
    'eventAdmins.newUser': 'Create new user (if it does not exist)',
    'eventAdmins.passwordMin': 'The password must be at least 8 characters long.',
    'eventAdmins.loadError': 'The administrator list could not be loaded.',
    'eventAdmins.ready': 'Done.',
    'eventAdmins.removed': 'Administrator removed.',
    'eventAdmins.removeError': 'The administrator could not be removed.',
    'eventAdmins.saveError': 'There was an error saving the administrator.',
    'eventAdmins.removeConfirm': 'Remove {email} as an administrator of this event?',
  },
};

export const normalizeUserManagementLanguage = (value) => value === 'en' ? 'en' : 'es';

export const getUserManagementLanguage = () => {
  if (typeof window === 'undefined') return 'es';
  try {
    return normalizeUserManagementLanguage(window.localStorage.getItem(USER_MANAGEMENT_LANGUAGE_KEY));
  } catch (_) {
    return 'es';
  }
};

export const setUserManagementLanguage = (language) => {
  const normalized = normalizeUserManagementLanguage(language);
  if (typeof window !== 'undefined') {
    try {
      window.localStorage.setItem(USER_MANAGEMENT_LANGUAGE_KEY, normalized);
    } catch (_) {
      // El selector sigue funcionando durante la sesión aunque el navegador bloquee storage.
    }
  }
  return normalized;
};

export const translateUserManagement = (language, key, params = {}) => {
  const normalized = normalizeUserManagementLanguage(language);
  const template = messages[normalized]?.[key] ?? messages.es[key] ?? key;

  return Object.entries(params).reduce(
    (text, [name, value]) => text.replace(new RegExp(`\\{${name}\\}`, 'g'), String(value ?? '')),
    template
  );
};

export const localizeUserManagementCategoryLabel = (language, value, category) => {
  const label = String(value || '').trim();
  const normalized = label.toLowerCase();
  const categories = {
    staff: { key: 'categories.staff', aliases: ['', 'staff'] },
    conferencistas: { key: 'categories.speakers', aliases: ['', 'expositores', 'expositor', 'conferencistas', 'conferencista'] },
    asistentes: { key: 'categories.attendees', aliases: ['', 'asistentes', 'asistente'] },
  };
  const config = categories[category];

  if (config?.aliases.includes(normalized)) {
    return translateUserManagement(language, config.key);
  }
  return label || category;
};

export const userManagementI18nMixin = {
  inject: {
    userManagementI18n: { default: null },
  },
  methods: {
    uiLanguageCode() {
      return this.userManagementI18n?.language?.value || getUserManagementLanguage();
    },
    uiT(key, params = {}) {
      if (this.userManagementI18n?.t) {
        return this.userManagementI18n.t(key, params);
      }
      return translateUserManagement(getUserManagementLanguage(), key, params);
    },
    uiCategoryLabel(value, category) {
      return localizeUserManagementCategoryLabel(this.uiLanguageCode(), value, category);
    },
  },
};
